
import Button from '../../../components/base/Button';

export default function AboutSection() {
  const stats = [
    { number: '15+', label: 'Years Experience' },
    { number: '500+', label: 'Happy Customers' },
    { number: '24/7', label: 'Emergency Service' },
    { number: '100%', label: 'Licensed & Insured' }
  ];

  return (
    <section id="about" className="py-20 bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Why Choose <span className="text-yellow-400">A&R Electric</span>?
            </h2>
            <p className="text-xl text-gray-300 mb-6 leading-relaxed">
              With over 15 years of experience in residential electrical services, A&R Electric has built 
              a reputation for excellence, reliability, and customer satisfaction.
            </p>
            <p className="text-gray-300 mb-8 leading-relaxed">
              We combine traditional craftsmanship with modern technology to deliver electrical solutions 
              that are not only functional but also enhance your home's value and safety. Our team of 
              licensed electricians is committed to providing personalized service that exceeds expectations.
            </p>

            {/* Features */}
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-gray-900 font-bold"></i>
                </div>
                <span className="text-white">Licensed & Insured</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-gray-900 font-bold"></i>
                </div>
                <span className="text-white">24/7 Emergency Service</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-gray-900 font-bold"></i>
                </div>
                <span className="text-white">Free Estimates</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-gray-900 font-bold"></i>
                </div>
                <span className="text-white">Quality Guarantee</span>
              </div>
            </div>

            <Button size="lg">
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-user-line"></i>
              </div>
              Meet Our Team
            </Button>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/082985e0a6b424ba0069db47980006f5.jpg"
                alt="A&R Electric Team"
                className="w-full h-96 object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 to-transparent"></div>
            </div>
            
            {/* Stats Overlay */}
            <div className="absolute -bottom-8 left-8 right-8 bg-gray-800 rounded-xl p-6 border border-gray-700">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {stats.map((stat, index) => (
                  <div key={index} className="text-center">
                    <div className="text-2xl font-bold text-yellow-400 mb-1">{stat.number}</div>
                    <div className="text-sm text-gray-300">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
